import LandingPageBanner from './LandingPageBanner';
import { LandingPageBannerProps, LandingPageBannerValueProps } from './types';

export type { LandingPageBannerProps, LandingPageBannerValueProps };
export default LandingPageBanner;
